/* app bootstrap */
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import * as Sentry from '@sentry/react'
import App from './App.tsx'
import './index.css'
import { preserveServerContent, dismissServerContent } from '@/lib/public-blog-ssr'

const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: true }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
  });
}

// Blog em domínio próprio: o HTML já veio com o conteúdo montado no servidor.
// Mantém esse conteúdo na tela enquanto o React carrega (nada de esqueleto).
const hadServerContent = preserveServerContent();

const rootEl = document.getElementById("root")!;
createRoot(rootEl).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// Assim que a página React tem conteúdo real (sem esqueleto), libera a casca
// do servidor. Teto curto para nunca deixar o blog escondido.
if (hadServerContent) {
  let done = false;
  const finish = () => {
    if (done) return;
    done = true;
    observer.disconnect();
    dismissServerContent();
  };
  const ready = () =>
    rootEl.childElementCount > 0 && !rootEl.querySelector(".animate-pulse");
  const observer = new MutationObserver(() => { if (ready()) finish(); });
  observer.observe(rootEl, { childList: true, subtree: true });
  window.setTimeout(finish, 2500);
}
